import React, { useState, useEffect } from "react";
import {
  TileLayout,
  TileLayoutRepositionEvent,
  Drawer,
  DrawerContent,
  DrawerItem,
  PanelBar,
  PanelBarItem,
} from "@progress/kendo-react-layout";
import { useSelector } from "react-redux";
import { isSearchStateDifferentFromDefault } from "../../Search/SearchSlice";

interface SidebarItemProps {
  item: any;
  title: string;
  expanded: boolean;
  default: boolean;
}

const SidebarItem = (props: SidebarItemProps) => {

    const searchFilterChange = useSelector(isSearchStateDifferentFromDefault);
    useEffect(() => {
        if (props.title == "Search Filters") {
            searchFilterChange ? updateClassName("sidebaritem") : updateClassName("");
        }
    }, [searchFilterChange]);

  const [className, updateClassName] = useState("");

  return (
    <div className={className}>
      <DrawerItem>
        <PanelBar keepItemsMounted={true}>
          <PanelBarItem expanded={props.expanded} title={props.title}>
            {props.item}
          </PanelBarItem>
        </PanelBar>
      </DrawerItem>
    </div>
  );
};
export default SidebarItem;
